import React from "react";

export default class SimpleText extends React.Component {
    render() {
        return <span>
            {this.props.text}
        </span>;
    }
}